export default "__VITE_ASSET__e11ed81e__"